// source: schedulemanager/schedulemanager.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
goog.exportSymbol('proto.schedulemanager.CreateUpdateScheduleRequest', null, global);
goog.exportSymbol('proto.schedulemanager.DeleteScheduleRequest', null, global);
goog.exportSymbol('proto.schedulemanager.EnableScheduleRequest', null, global);
goog.exportSymbol('proto.schedulemanager.EvidenceCollectionExecution', null, global);
goog.exportSymbol('proto.schedulemanager.ExamineAndTestExecution', null, global);
goog.exportSymbol('proto.schedulemanager.ExecutionMetadata', null, global);
goog.exportSymbol('proto.schedulemanager.GetScheduleRequest', null, global);
goog.exportSymbol('proto.schedulemanager.NotificationsExecution', null, global);
goog.exportSymbol('proto.schedulemanager.SCHEDULE_EXPRESSION_TYPE', null, global);
goog.exportSymbol('proto.schedulemanager.SCHEDULE_OCCURRENCE', null, global);
goog.exportSymbol('proto.schedulemanager.SCHEDULE_RATE_UNIT', null, global);
goog.exportSymbol('proto.schedulemanager.SCHEDULE_STATUS', null, global);
goog.exportSymbol('proto.schedulemanager.SCHEDULE_TYPE', null, global);
goog.exportSymbol('proto.schedulemanager.ScheduleExecution', null, global);
goog.exportSymbol('proto.schedulemanager.SchedulePattern', null, global);
goog.exportSymbol('proto.schedulemanager.ScheduleRecord', null, global);
goog.exportSymbol('proto.schedulemanager.SchedulesResponse', null, global);
goog.exportSymbol('proto.schedulemanager.TickRequest', null, global);
goog.exportSymbol('proto.schedulemanager.TickResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.schedulemanager.TickRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.schedulemanager.TickRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.schedulemanager.TickRequest.displayName = 'proto.schedulemanager.TickRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.schedulemanager.TickResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.schedulemanager.TickResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.schedulemanager.TickResponse.displayName = 'proto.schedulemanager.TickResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.schedulemanager.GetScheduleRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.schedulemanager.GetScheduleRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.schedulemanager.GetScheduleRequest.displayName = 'proto.schedulemanager.GetScheduleRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.schedulemanager.SchedulePattern = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.schedulemanager.SchedulePattern, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.schedulemanager.SchedulePattern.displayName = 'proto.schedulemanager.SchedulePattern';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.schedulemanager.ExecutionMetadata = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.schedulemanager.ExecutionMetadata, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.schedulemanager.ExecutionMetadata.displayName = 'proto.schedulemanager.ExecutionMetadata';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.schedulemanager.EvidenceCollectionExecution = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.schedulemanager.EvidenceCollectionExecution.repeatedFields_, null);
};
goog.inherits(proto.schedulemanager.EvidenceCollectionExecution, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.schedulemanager.EvidenceCollectionExecution.displayName = 'proto.schedulemanager.EvidenceCollectionExecution';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.schedulemanager.ExamineAndTestExecution = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.schedulemanager.ExamineAndTestExecution, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.schedulemanager.ExamineAndTestExecution.displayName = 'proto.schedulemanager.ExamineAndTestExecution';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.schedulemanager.NotificationsExecution = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.schedulemanager.NotificationsExecution.repeatedFields_, null);
};
goog.inherits(proto.schedulemanager.NotificationsExecution, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.schedulemanager.NotificationsExecution.displayName = 'proto.schedulemanager.NotificationsExecution';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.schedulemanager.ScheduleExecution = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.schedulemanager.ScheduleExecution, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.schedulemanager.ScheduleExecution.displayName = 'proto.schedulemanager.ScheduleExecution';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.schedulemanager.ScheduleRecord = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.schedulemanager.ScheduleRecord.repeatedFields_, null);
};
goog.inherits(proto.schedulemanager.ScheduleRecord, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.schedulemanager.ScheduleRecord.displayName = 'proto.schedulemanager.ScheduleRecord';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.schedulemanager.CreateUpdateScheduleRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.schedulemanager.CreateUpdateScheduleRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.schedulemanager.CreateUpdateScheduleRequest.displayName = 'proto.schedulemanager.CreateUpdateScheduleRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.schedulemanager.DeleteScheduleRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.schedulemanager.DeleteScheduleRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.schedulemanager.DeleteScheduleRequest.displayName = 'proto.schedulemanager.DeleteScheduleRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.schedulemanager.SchedulesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.schedulemanager.SchedulesResponse.repeatedFields_, null);
};
goog.inherits(proto.schedulemanager.SchedulesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.schedulemanager.SchedulesResponse.displayName = 'proto.schedulemanager.SchedulesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.schedulemanager.EnableScheduleRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.schedulemanager.EnableScheduleRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.schedulemanager.EnableScheduleRequest.displayName = 'proto.schedulemanager.EnableScheduleRequest';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.schedulemanager.TickRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.schedulemanager.TickRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.schedulemanager.TickRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.schedulemanager.TickRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    isdryrun: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.schedulemanager.TickRequest}
 */
proto.schedulemanager.TickRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.schedulemanager.TickRequest;
  return proto.schedulemanager.TickRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.schedulemanager.TickRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.schedulemanager.TickRequest}
 */
proto.schedulemanager.TickRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsdryrun(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.schedulemanager.TickRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.schedulemanager.TickRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.schedulemanager.TickRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.schedulemanager.TickRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsdryrun();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool isDryRun = 1;
 * @return {boolean}
 */
proto.schedulemanager.TickRequest.prototype.getIsdryrun = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.schedulemanager.TickRequest} returns this
 */
proto.schedulemanager.TickRequest.prototype.setIsdryrun = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.schedulemanager.TickResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.schedulemanager.TickResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.schedulemanager.TickResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.schedulemanager.TickResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    message: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.schedulemanager.TickResponse}
 */
proto.schedulemanager.TickResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.schedulemanager.TickResponse;
  return proto.schedulemanager.TickResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.schedulemanager.TickResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.schedulemanager.TickResponse}
 */
proto.schedulemanager.TickResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.schedulemanager.TickResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.schedulemanager.TickResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.schedulemanager.TickResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.schedulemanager.TickResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string message = 1;
 * @return {string}
 */
proto.schedulemanager.TickResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.schedulemanager.TickResponse} returns this
 */
proto.schedulemanager.TickResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.schedulemanager.GetScheduleRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.schedulemanager.GetScheduleRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.schedulemanager.GetScheduleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.schedulemanager.GetScheduleRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.schedulemanager.GetScheduleRequest}
 */
proto.schedulemanager.GetScheduleRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.schedulemanager.GetScheduleRequest;
  return proto.schedulemanager.GetScheduleRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.schedulemanager.GetScheduleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.schedulemanager.GetScheduleRequest}
 */
proto.schedulemanager.GetScheduleRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.schedulemanager.GetScheduleRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.schedulemanager.GetScheduleRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.schedulemanager.GetScheduleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.schedulemanager.GetScheduleRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string id = 2;
 * @return {string}
 */
proto.schedulemanager.GetScheduleRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.schedulemanager.GetScheduleRequest} returns this
 */
proto.schedulemanager.GetScheduleRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.schedulemanager.SchedulePattern.prototype.toObject = function(opt_includeInstance) {
  return proto.schedulemanager.SchedulePattern.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.schedulemanager.SchedulePattern} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.schedulemanager.SchedulePattern.toObject = function(includeInstance, msg) {
  var f, obj = {
    occurrence: jspb.Message.getFieldWithDefault(msg, 1, 0),
    expressionType: jspb.Message.getFieldWithDefault(msg, 2, 0),
    rateValue: jspb.Message.getFieldWithDefault(msg, 3, 0),
    rateUnit: jspb.Message.getFieldWithDefault(msg, 4, 0),
    cronExpression: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.schedulemanager.SchedulePattern}
 */
proto.schedulemanager.SchedulePattern.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.schedulemanager.SchedulePattern;
  return proto.schedulemanager.SchedulePattern.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.schedulemanager.SchedulePattern} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.schedulemanager.SchedulePattern}
 */
proto.schedulemanager.SchedulePattern.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.schedulemanager.SCHEDULE_OCCURRENCE} */ (reader.readEnum());
      msg.setOccurrence(value);
      break;
    case 2:
      var value = /** @type {!proto.schedulemanager.SCHEDULE_EXPRESSION_TYPE} */ (reader.readEnum());
      msg.setExpressionType(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRateValue(value);
      break;
    case 4:
      var value = /** @type {!proto.schedulemanager.SCHEDULE_RATE_UNIT} */ (reader.readEnum());
      msg.setRateUnit(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCronExpression(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.schedulemanager.SchedulePattern.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.schedulemanager.SchedulePattern.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.schedulemanager.SchedulePattern} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.schedulemanager.SchedulePattern.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOccurrence();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getExpressionType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getRateValue();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getRateUnit();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getCronExpression();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional SCHEDULE_OCCURRENCE occurrence = 1;
 * @return {!proto.schedulemanager.SCHEDULE_OCCURRENCE}
 */
proto.schedulemanager.SchedulePattern.prototype.getOccurrence = function() {
  return /** @type {!proto.schedulemanager.SCHEDULE_OCCURRENCE} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.schedulemanager.SCHEDULE_OCCURRENCE} value
 * @return {!proto.schedulemanager.SchedulePattern} returns this
 */
proto.schedulemanager.SchedulePattern.prototype.setOccurrence = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional SCHEDULE_EXPRESSION_TYPE expression_type = 2;
 * @return {!proto.schedulemanager.SCHEDULE_EXPRESSION_TYPE}
 */
proto.schedulemanager.SchedulePattern.prototype.getExpressionType = function() {
  return /** @type {!proto.schedulemanager.SCHEDULE_EXPRESSION_TYPE} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.schedulemanager.SCHEDULE_EXPRESSION_TYPE} value
 * @return {!proto.schedulemanager.SchedulePattern} returns this
 */
proto.schedulemanager.SchedulePattern.prototype.setExpressionType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional int32 rate_value = 3;
 * @return {number}
 */
proto.schedulemanager.SchedulePattern.prototype.getRateValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.schedulemanager.SchedulePattern} returns this
 */
proto.schedulemanager.SchedulePattern.prototype.setRateValue = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional SCHEDULE_RATE_UNIT rate_unit = 4;
 * @return {!proto.schedulemanager.SCHEDULE_RATE_UNIT}
 */
proto.schedulemanager.SchedulePattern.prototype.getRateUnit = function() {
  return /** @type {!proto.schedulemanager.SCHEDULE_RATE_UNIT} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.schedulemanager.SCHEDULE_RATE_UNIT} value
 * @return {!proto.schedulemanager.SchedulePattern} returns this
 */
proto.schedulemanager.SchedulePattern.prototype.setRateUnit = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string cron_expression = 5;
 * @return {string}
 */
proto.schedulemanager.SchedulePattern.prototype.getCronExpression = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.schedulemanager.SchedulePattern} returns this
 */
proto.schedulemanager.SchedulePattern.prototype.setCronExpression = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.schedulemanager.ExecutionMetadata.prototype.toObject = function(opt_includeInstance) {
  return proto.schedulemanager.ExecutionMetadata.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.schedulemanager.ExecutionMetadata} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.schedulemanager.ExecutionMetadata.toObject = function(includeInstance, msg) {
  var f, obj = {
    startTime: jspb.Message.getFieldWithDefault(msg, 1, 0),
    endTime: jspb.Message.getFieldWithDefault(msg, 2, 0),
    summary: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.schedulemanager.ExecutionMetadata}
 */
proto.schedulemanager.ExecutionMetadata.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.schedulemanager.ExecutionMetadata;
  return proto.schedulemanager.ExecutionMetadata.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.schedulemanager.ExecutionMetadata} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.schedulemanager.ExecutionMetadata}
 */
proto.schedulemanager.ExecutionMetadata.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStartTime(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEndTime(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSummary(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.schedulemanager.ExecutionMetadata.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.schedulemanager.ExecutionMetadata.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.schedulemanager.ExecutionMetadata} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.schedulemanager.ExecutionMetadata.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStartTime();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getEndTime();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getSummary();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional int64 start_time = 1;
 * @return {number}
 */
proto.schedulemanager.ExecutionMetadata.prototype.getStartTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.schedulemanager.ExecutionMetadata} returns this
 */
proto.schedulemanager.ExecutionMetadata.prototype.setStartTime = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 end_time = 2;
 * @return {number}
 */
proto.schedulemanager.ExecutionMetadata.prototype.getEndTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.schedulemanager.ExecutionMetadata} returns this
 */
proto.schedulemanager.ExecutionMetadata.prototype.setEndTime = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string summary = 3;
 * @return {string}
 */
proto.schedulemanager.ExecutionMetadata.prototype.getSummary = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.schedulemanager.ExecutionMetadata} returns this
 */
proto.schedulemanager.ExecutionMetadata.prototype.setSummary = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.schedulemanager.EvidenceCollectionExecution.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.schedulemanager.EvidenceCollectionExecution.prototype.toObject = function(opt_includeInstance) {
  return proto.schedulemanager.EvidenceCollectionExecution.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.schedulemanager.EvidenceCollectionExecution} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.schedulemanager.EvidenceCollectionExecution.toObject = function(includeInstance, msg) {
  var f, obj = {
    metadata: (f = msg.getMetadata()) && proto.schedulemanager.ExecutionMetadata.toObject(includeInstance, f),
    discoveryIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.schedulemanager.EvidenceCollectionExecution}
 */
proto.schedulemanager.EvidenceCollectionExecution.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.schedulemanager.EvidenceCollectionExecution;
  return proto.schedulemanager.EvidenceCollectionExecution.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.schedulemanager.EvidenceCollectionExecution} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.schedulemanager.EvidenceCollectionExecution}
 */
proto.schedulemanager.EvidenceCollectionExecution.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.schedulemanager.ExecutionMetadata;
      reader.readMessage(value,proto.schedulemanager.ExecutionMetadata.deserializeBinaryFromReader);
      msg.setMetadata(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addDiscoveryIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.schedulemanager.EvidenceCollectionExecution.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.schedulemanager.EvidenceCollectionExecution.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.schedulemanager.EvidenceCollectionExecution} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.schedulemanager.EvidenceCollectionExecution.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMetadata();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.schedulemanager.ExecutionMetadata.serializeBinaryToWriter
    );
  }
  f = message.getDiscoveryIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional ExecutionMetadata metadata = 1;
 * @return {?proto.schedulemanager.ExecutionMetadata}
 */
proto.schedulemanager.EvidenceCollectionExecution.prototype.getMetadata = function() {
  return /** @type{?proto.schedulemanager.ExecutionMetadata} */ (
    jspb.Message.getWrapperField(this, proto.schedulemanager.ExecutionMetadata, 1));
};


/**
 * @param {?proto.schedulemanager.ExecutionMetadata|undefined} value
 * @return {!proto.schedulemanager.EvidenceCollectionExecution} returns this
*/
proto.schedulemanager.EvidenceCollectionExecution.prototype.setMetadata = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.schedulemanager.EvidenceCollectionExecution} returns this
 */
proto.schedulemanager.EvidenceCollectionExecution.prototype.clearMetadata = function() {
  return this.setMetadata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.schedulemanager.EvidenceCollectionExecution.prototype.hasMetadata = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated string discovery_ids = 2;
 * @return {!Array<string>}
 */
proto.schedulemanager.EvidenceCollectionExecution.prototype.getDiscoveryIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.schedulemanager.EvidenceCollectionExecution} returns this
 */
proto.schedulemanager.EvidenceCollectionExecution.prototype.setDiscoveryIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.schedulemanager.EvidenceCollectionExecution} returns this
 */
proto.schedulemanager.EvidenceCollectionExecution.prototype.addDiscoveryIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.schedulemanager.EvidenceCollectionExecution} returns this
 */
proto.schedulemanager.EvidenceCollectionExecution.prototype.clearDiscoveryIdsList = function() {
  return this.setDiscoveryIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.schedulemanager.ExamineAndTestExecution.prototype.toObject = function(opt_includeInstance) {
  return proto.schedulemanager.ExamineAndTestExecution.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.schedulemanager.ExamineAndTestExecution} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.schedulemanager.ExamineAndTestExecution.toObject = function(includeInstance, msg) {
  var f, obj = {
    metadata: (f = msg.getMetadata()) && proto.schedulemanager.ExecutionMetadata.toObject(includeInstance, f),
    auditRunId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.schedulemanager.ExamineAndTestExecution}
 */
proto.schedulemanager.ExamineAndTestExecution.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.schedulemanager.ExamineAndTestExecution;
  return proto.schedulemanager.ExamineAndTestExecution.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.schedulemanager.ExamineAndTestExecution} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.schedulemanager.ExamineAndTestExecution}
 */
proto.schedulemanager.ExamineAndTestExecution.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.schedulemanager.ExecutionMetadata;
      reader.readMessage(value,proto.schedulemanager.ExecutionMetadata.deserializeBinaryFromReader);
      msg.setMetadata(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuditRunId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.schedulemanager.ExamineAndTestExecution.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.schedulemanager.ExamineAndTestExecution.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.schedulemanager.ExamineAndTestExecution} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.schedulemanager.ExamineAndTestExecution.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMetadata();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.schedulemanager.ExecutionMetadata.serializeBinaryToWriter
    );
  }
  f = message.getAuditRunId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional ExecutionMetadata metadata = 1;
 * @return {?proto.schedulemanager.ExecutionMetadata}
 */
proto.schedulemanager.ExamineAndTestExecution.prototype.getMetadata = function() {
  return /** @type{?proto.schedulemanager.ExecutionMetadata} */ (
    jspb.Message.getWrapperField(this, proto.schedulemanager.ExecutionMetadata, 1));
};


/**
 * @param {?proto.schedulemanager.ExecutionMetadata|undefined} value
 * @return {!proto.schedulemanager.ExamineAndTestExecution} returns this
*/
proto.schedulemanager.ExamineAndTestExecution.prototype.setMetadata = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.schedulemanager.ExamineAndTestExecution} returns this
 */
proto.schedulemanager.ExamineAndTestExecution.prototype.clearMetadata = function() {
  return this.setMetadata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.schedulemanager.ExamineAndTestExecution.prototype.hasMetadata = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string audit_run_id = 2;
 * @return {string}
 */
proto.schedulemanager.ExamineAndTestExecution.prototype.getAuditRunId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.schedulemanager.ExamineAndTestExecution} returns this
 */
proto.schedulemanager.ExamineAndTestExecution.prototype.setAuditRunId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.schedulemanager.NotificationsExecution.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.schedulemanager.NotificationsExecution.prototype.toObject = function(opt_includeInstance) {
  return proto.schedulemanager.NotificationsExecution.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.schedulemanager.NotificationsExecution} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.schedulemanager.NotificationsExecution.toObject = function(includeInstance, msg) {
  var f, obj = {
    usersList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.schedulemanager.NotificationsExecution}
 */
proto.schedulemanager.NotificationsExecution.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.schedulemanager.NotificationsExecution;
  return proto.schedulemanager.NotificationsExecution.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.schedulemanager.NotificationsExecution} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.schedulemanager.NotificationsExecution}
 */
proto.schedulemanager.NotificationsExecution.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addUsers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.schedulemanager.NotificationsExecution.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.schedulemanager.NotificationsExecution.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.schedulemanager.NotificationsExecution} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.schedulemanager.NotificationsExecution.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsersList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string users = 1;
 * @return {!Array<string>}
 */
proto.schedulemanager.NotificationsExecution.prototype.getUsersList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.schedulemanager.NotificationsExecution} returns this
 */
proto.schedulemanager.NotificationsExecution.prototype.setUsersList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.schedulemanager.NotificationsExecution} returns this
 */
proto.schedulemanager.NotificationsExecution.prototype.addUsers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.schedulemanager.NotificationsExecution} returns this
 */
proto.schedulemanager.NotificationsExecution.prototype.clearUsersList = function() {
  return this.setUsersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.schedulemanager.ScheduleExecution.prototype.toObject = function(opt_includeInstance) {
  return proto.schedulemanager.ScheduleExecution.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.schedulemanager.ScheduleExecution} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.schedulemanager.ScheduleExecution.toObject = function(includeInstance, msg) {
  var f, obj = {
    evidenceCollection: (f = msg.getEvidenceCollection()) && proto.schedulemanager.EvidenceCollectionExecution.toObject(includeInstance, f),
    examineAndTest: (f = msg.getExamineAndTest()) && proto.schedulemanager.ExamineAndTestExecution.toObject(includeInstance, f),
    notifications: (f = msg.getNotifications()) && proto.schedulemanager.NotificationsExecution.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.schedulemanager.ScheduleExecution}
 */
proto.schedulemanager.ScheduleExecution.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.schedulemanager.ScheduleExecution;
  return proto.schedulemanager.ScheduleExecution.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.schedulemanager.ScheduleExecution} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.schedulemanager.ScheduleExecution}
 */
proto.schedulemanager.ScheduleExecution.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.schedulemanager.EvidenceCollectionExecution;
      reader.readMessage(value,proto.schedulemanager.EvidenceCollectionExecution.deserializeBinaryFromReader);
      msg.setEvidenceCollection(value);
      break;
    case 2:
      var value = new proto.schedulemanager.ExamineAndTestExecution;
      reader.readMessage(value,proto.schedulemanager.ExamineAndTestExecution.deserializeBinaryFromReader);
      msg.setExamineAndTest(value);
      break;
    case 3:
      var value = new proto.schedulemanager.NotificationsExecution;
      reader.readMessage(value,proto.schedulemanager.NotificationsExecution.deserializeBinaryFromReader);
      msg.setNotifications(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.schedulemanager.ScheduleExecution.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.schedulemanager.ScheduleExecution.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.schedulemanager.ScheduleExecution} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.schedulemanager.ScheduleExecution.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEvidenceCollection();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.schedulemanager.EvidenceCollectionExecution.serializeBinaryToWriter
    );
  }
  f = message.getExamineAndTest();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.schedulemanager.ExamineAndTestExecution.serializeBinaryToWriter
    );
  }
  f = message.getNotifications();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.schedulemanager.NotificationsExecution.serializeBinaryToWriter
    );
  }
};


/**
 * optional EvidenceCollectionExecution evidence_collection = 1;
 * @return {?proto.schedulemanager.EvidenceCollectionExecution}
 */
proto.schedulemanager.ScheduleExecution.prototype.getEvidenceCollection = function() {
  return /** @type{?proto.schedulemanager.EvidenceCollectionExecution} */ (
    jspb.Message.getWrapperField(this, proto.schedulemanager.EvidenceCollectionExecution, 1));
};


/**
 * @param {?proto.schedulemanager.EvidenceCollectionExecution|undefined} value
 * @return {!proto.schedulemanager.ScheduleExecution} returns this
*/
proto.schedulemanager.ScheduleExecution.prototype.setEvidenceCollection = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.schedulemanager.ScheduleExecution} returns this
 */
proto.schedulemanager.ScheduleExecution.prototype.clearEvidenceCollection = function() {
  return this.setEvidenceCollection(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.schedulemanager.ScheduleExecution.prototype.hasEvidenceCollection = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ExamineAndTestExecution examine_and_test = 2;
 * @return {?proto.schedulemanager.ExamineAndTestExecution}
 */
proto.schedulemanager.ScheduleExecution.prototype.getExamineAndTest = function() {
  return /** @type{?proto.schedulemanager.ExamineAndTestExecution} */ (
    jspb.Message.getWrapperField(this, proto.schedulemanager.ExamineAndTestExecution, 2));
};


/**
 * @param {?proto.schedulemanager.ExamineAndTestExecution|undefined} value
 * @return {!proto.schedulemanager.ScheduleExecution} returns this
*/
proto.schedulemanager.ScheduleExecution.prototype.setExamineAndTest = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.schedulemanager.ScheduleExecution} returns this
 */
proto.schedulemanager.ScheduleExecution.prototype.clearExamineAndTest = function() {
  return this.setExamineAndTest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.schedulemanager.ScheduleExecution.prototype.hasExamineAndTest = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional NotificationsExecution notifications = 3;
 * @return {?proto.schedulemanager.NotificationsExecution}
 */
proto.schedulemanager.ScheduleExecution.prototype.getNotifications = function() {
  return /** @type{?proto.schedulemanager.NotificationsExecution} */ (
    jspb.Message.getWrapperField(this, proto.schedulemanager.NotificationsExecution, 3));
};


/**
 * @param {?proto.schedulemanager.NotificationsExecution|undefined} value
 * @return {!proto.schedulemanager.ScheduleExecution} returns this
*/
proto.schedulemanager.ScheduleExecution.prototype.setNotifications = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.schedulemanager.ScheduleExecution} returns this
 */
proto.schedulemanager.ScheduleExecution.prototype.clearNotifications = function() {
  return this.setNotifications(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.schedulemanager.ScheduleExecution.prototype.hasNotifications = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.schedulemanager.ScheduleRecord.repeatedFields_ = [4,14];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.schedulemanager.ScheduleRecord.prototype.toObject = function(opt_includeInstance) {
  return proto.schedulemanager.ScheduleRecord.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.schedulemanager.ScheduleRecord} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.schedulemanager.ScheduleRecord.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    scheduleTypesList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    lastRunAt: (f = msg.getLastRunAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    nextRunAt: (f = msg.getNextRunAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    pattern: (f = msg.getPattern()) && proto.schedulemanager.SchedulePattern.toObject(includeInstance, f),
    parameters: jspb.Message.getFieldWithDefault(msg, 12, ""),
    enabled: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
    executionsList: jspb.Message.toObjectList(msg.getExecutionsList(),
    proto.schedulemanager.ScheduleExecution.toObject, includeInstance),
    lastRunStatus: jspb.Message.getFieldWithDefault(msg, 15, 0),
    lastScheduleRunId: jspb.Message.getFieldWithDefault(msg, 16, ""),
    name: jspb.Message.getFieldWithDefault(msg, 17, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.schedulemanager.ScheduleRecord}
 */
proto.schedulemanager.ScheduleRecord.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.schedulemanager.ScheduleRecord;
  return proto.schedulemanager.ScheduleRecord.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.schedulemanager.ScheduleRecord} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.schedulemanager.ScheduleRecord}
 */
proto.schedulemanager.ScheduleRecord.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 4:
      var values = /** @type {!Array<!proto.schedulemanager.SCHEDULE_TYPE>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addScheduleTypes(values[i]);
      }
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastRunAt(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setNextRunAt(value);
      break;
    case 10:
      var value = new proto.schedulemanager.SchedulePattern;
      reader.readMessage(value,proto.schedulemanager.SchedulePattern.deserializeBinaryFromReader);
      msg.setPattern(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setParameters(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    case 14:
      var value = new proto.schedulemanager.ScheduleExecution;
      reader.readMessage(value,proto.schedulemanager.ScheduleExecution.deserializeBinaryFromReader);
      msg.addExecutions(value);
      break;
    case 15:
      var value = /** @type {!proto.schedulemanager.SCHEDULE_STATUS} */ (reader.readEnum());
      msg.setLastRunStatus(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastScheduleRunId(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.schedulemanager.ScheduleRecord.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.schedulemanager.ScheduleRecord.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.schedulemanager.ScheduleRecord} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.schedulemanager.ScheduleRecord.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getScheduleTypesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      4,
      f
    );
  }
  f = message.getLastRunAt();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getNextRunAt();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPattern();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.schedulemanager.SchedulePattern.serializeBinaryToWriter
    );
  }
  f = message.getParameters();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getExecutionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      14,
      f,
      proto.schedulemanager.ScheduleExecution.serializeBinaryToWriter
    );
  }
  f = message.getLastRunStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      15,
      f
    );
  }
  f = message.getLastScheduleRunId();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.schedulemanager.ScheduleRecord.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.schedulemanager.ScheduleRecord} returns this
 */
proto.schedulemanager.ScheduleRecord.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.schedulemanager.ScheduleRecord.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.schedulemanager.ScheduleRecord} returns this
*/
proto.schedulemanager.ScheduleRecord.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.schedulemanager.ScheduleRecord} returns this
 */
proto.schedulemanager.ScheduleRecord.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.schedulemanager.ScheduleRecord.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.schedulemanager.ScheduleRecord.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.schedulemanager.ScheduleRecord} returns this
*/
proto.schedulemanager.ScheduleRecord.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.schedulemanager.ScheduleRecord} returns this
 */
proto.schedulemanager.ScheduleRecord.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.schedulemanager.ScheduleRecord.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated SCHEDULE_TYPE schedule_types = 4;
 * @return {!Array<!proto.schedulemanager.SCHEDULE_TYPE>}
 */
proto.schedulemanager.ScheduleRecord.prototype.getScheduleTypesList = function() {
  return /** @type {!Array<!proto.schedulemanager.SCHEDULE_TYPE>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<!proto.schedulemanager.SCHEDULE_TYPE>} value
 * @return {!proto.schedulemanager.ScheduleRecord} returns this
 */
proto.schedulemanager.ScheduleRecord.prototype.setScheduleTypesList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {!proto.schedulemanager.SCHEDULE_TYPE} value
 * @param {number=} opt_index
 * @return {!proto.schedulemanager.ScheduleRecord} returns this
 */
proto.schedulemanager.ScheduleRecord.prototype.addScheduleTypes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.schedulemanager.ScheduleRecord} returns this
 */
proto.schedulemanager.ScheduleRecord.prototype.clearScheduleTypesList = function() {
  return this.setScheduleTypesList([]);
};


/**
 * optional google.protobuf.Timestamp last_run_at = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.schedulemanager.ScheduleRecord.prototype.getLastRunAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.schedulemanager.ScheduleRecord} returns this
*/
proto.schedulemanager.ScheduleRecord.prototype.setLastRunAt = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.schedulemanager.ScheduleRecord} returns this
 */
proto.schedulemanager.ScheduleRecord.prototype.clearLastRunAt = function() {
  return this.setLastRunAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.schedulemanager.ScheduleRecord.prototype.hasLastRunAt = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.Timestamp next_run_at = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.schedulemanager.ScheduleRecord.prototype.getNextRunAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.schedulemanager.ScheduleRecord} returns this
*/
proto.schedulemanager.ScheduleRecord.prototype.setNextRunAt = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.schedulemanager.ScheduleRecord} returns this
 */
proto.schedulemanager.ScheduleRecord.prototype.clearNextRunAt = function() {
  return this.setNextRunAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.schedulemanager.ScheduleRecord.prototype.hasNextRunAt = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional SchedulePattern pattern = 10;
 * @return {?proto.schedulemanager.SchedulePattern}
 */
proto.schedulemanager.ScheduleRecord.prototype.getPattern = function() {
  return /** @type{?proto.schedulemanager.SchedulePattern} */ (
    jspb.Message.getWrapperField(this, proto.schedulemanager.SchedulePattern, 10));
};


/**
 * @param {?proto.schedulemanager.SchedulePattern|undefined} value
 * @return {!proto.schedulemanager.ScheduleRecord} returns this
*/
proto.schedulemanager.ScheduleRecord.prototype.setPattern = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.schedulemanager.ScheduleRecord} returns this
 */
proto.schedulemanager.ScheduleRecord.prototype.clearPattern = function() {
  return this.setPattern(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.schedulemanager.ScheduleRecord.prototype.hasPattern = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional string parameters = 12;
 * @return {string}
 */
proto.schedulemanager.ScheduleRecord.prototype.getParameters = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.schedulemanager.ScheduleRecord} returns this
 */
proto.schedulemanager.ScheduleRecord.prototype.setParameters = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional bool enabled = 13;
 * @return {boolean}
 */
proto.schedulemanager.ScheduleRecord.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.schedulemanager.ScheduleRecord} returns this
 */
proto.schedulemanager.ScheduleRecord.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * repeated ScheduleExecution executions = 14;
 * @return {!Array<!proto.schedulemanager.ScheduleExecution>}
 */
proto.schedulemanager.ScheduleRecord.prototype.getExecutionsList = function() {
  return /** @type{!Array<!proto.schedulemanager.ScheduleExecution>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.schedulemanager.ScheduleExecution, 14));
};


/**
 * @param {!Array<!proto.schedulemanager.ScheduleExecution>} value
 * @return {!proto.schedulemanager.ScheduleRecord} returns this
*/
proto.schedulemanager.ScheduleRecord.prototype.setExecutionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 14, value);
};


/**
 * @param {!proto.schedulemanager.ScheduleExecution=} opt_value
 * @param {number=} opt_index
 * @return {!proto.schedulemanager.ScheduleExecution}
 */
proto.schedulemanager.ScheduleRecord.prototype.addExecutions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 14, opt_value, proto.schedulemanager.ScheduleExecution, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.schedulemanager.ScheduleRecord} returns this
 */
proto.schedulemanager.ScheduleRecord.prototype.clearExecutionsList = function() {
  return this.setExecutionsList([]);
};


/**
 * optional SCHEDULE_STATUS last_run_status = 15;
 * @return {!proto.schedulemanager.SCHEDULE_STATUS}
 */
proto.schedulemanager.ScheduleRecord.prototype.getLastRunStatus = function() {
  return /** @type {!proto.schedulemanager.SCHEDULE_STATUS} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {!proto.schedulemanager.SCHEDULE_STATUS} value
 * @return {!proto.schedulemanager.ScheduleRecord} returns this
 */
proto.schedulemanager.ScheduleRecord.prototype.setLastRunStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 15, value);
};


/**
 * optional string last_schedule_run_id = 16;
 * @return {string}
 */
proto.schedulemanager.ScheduleRecord.prototype.getLastScheduleRunId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.schedulemanager.ScheduleRecord} returns this
 */
proto.schedulemanager.ScheduleRecord.prototype.setLastScheduleRunId = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string name = 17;
 * @return {string}
 */
proto.schedulemanager.ScheduleRecord.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.schedulemanager.ScheduleRecord} returns this
 */
proto.schedulemanager.ScheduleRecord.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.schedulemanager.CreateUpdateScheduleRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.schedulemanager.CreateUpdateScheduleRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.schedulemanager.CreateUpdateScheduleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.schedulemanager.CreateUpdateScheduleRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    parameters: jspb.Message.getFieldWithDefault(msg, 3, ""),
    pattern: (f = msg.getPattern()) && proto.schedulemanager.SchedulePattern.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 5, ""),
    enabled: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    name: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.schedulemanager.CreateUpdateScheduleRequest}
 */
proto.schedulemanager.CreateUpdateScheduleRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.schedulemanager.CreateUpdateScheduleRequest;
  return proto.schedulemanager.CreateUpdateScheduleRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.schedulemanager.CreateUpdateScheduleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.schedulemanager.CreateUpdateScheduleRequest}
 */
proto.schedulemanager.CreateUpdateScheduleRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setParameters(value);
      break;
    case 4:
      var value = new proto.schedulemanager.SchedulePattern;
      reader.readMessage(value,proto.schedulemanager.SchedulePattern.deserializeBinaryFromReader);
      msg.setPattern(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.schedulemanager.CreateUpdateScheduleRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.schedulemanager.CreateUpdateScheduleRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.schedulemanager.CreateUpdateScheduleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.schedulemanager.CreateUpdateScheduleRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getParameters();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPattern();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.schedulemanager.SchedulePattern.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string parameters = 3;
 * @return {string}
 */
proto.schedulemanager.CreateUpdateScheduleRequest.prototype.getParameters = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.schedulemanager.CreateUpdateScheduleRequest} returns this
 */
proto.schedulemanager.CreateUpdateScheduleRequest.prototype.setParameters = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional SchedulePattern pattern = 4;
 * @return {?proto.schedulemanager.SchedulePattern}
 */
proto.schedulemanager.CreateUpdateScheduleRequest.prototype.getPattern = function() {
  return /** @type{?proto.schedulemanager.SchedulePattern} */ (
    jspb.Message.getWrapperField(this, proto.schedulemanager.SchedulePattern, 4));
};


/**
 * @param {?proto.schedulemanager.SchedulePattern|undefined} value
 * @return {!proto.schedulemanager.CreateUpdateScheduleRequest} returns this
*/
proto.schedulemanager.CreateUpdateScheduleRequest.prototype.setPattern = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.schedulemanager.CreateUpdateScheduleRequest} returns this
 */
proto.schedulemanager.CreateUpdateScheduleRequest.prototype.clearPattern = function() {
  return this.setPattern(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.schedulemanager.CreateUpdateScheduleRequest.prototype.hasPattern = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string id = 5;
 * @return {string}
 */
proto.schedulemanager.CreateUpdateScheduleRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.schedulemanager.CreateUpdateScheduleRequest} returns this
 */
proto.schedulemanager.CreateUpdateScheduleRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool enabled = 6;
 * @return {boolean}
 */
proto.schedulemanager.CreateUpdateScheduleRequest.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.schedulemanager.CreateUpdateScheduleRequest} returns this
 */
proto.schedulemanager.CreateUpdateScheduleRequest.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional string name = 7;
 * @return {string}
 */
proto.schedulemanager.CreateUpdateScheduleRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.schedulemanager.CreateUpdateScheduleRequest} returns this
 */
proto.schedulemanager.CreateUpdateScheduleRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.schedulemanager.DeleteScheduleRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.schedulemanager.DeleteScheduleRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.schedulemanager.DeleteScheduleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.schedulemanager.DeleteScheduleRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.schedulemanager.DeleteScheduleRequest}
 */
proto.schedulemanager.DeleteScheduleRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.schedulemanager.DeleteScheduleRequest;
  return proto.schedulemanager.DeleteScheduleRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.schedulemanager.DeleteScheduleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.schedulemanager.DeleteScheduleRequest}
 */
proto.schedulemanager.DeleteScheduleRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.schedulemanager.DeleteScheduleRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.schedulemanager.DeleteScheduleRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.schedulemanager.DeleteScheduleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.schedulemanager.DeleteScheduleRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.schedulemanager.DeleteScheduleRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.schedulemanager.DeleteScheduleRequest} returns this
 */
proto.schedulemanager.DeleteScheduleRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.schedulemanager.SchedulesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.schedulemanager.SchedulesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.schedulemanager.SchedulesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.schedulemanager.SchedulesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.schedulemanager.SchedulesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    schedulesList: jspb.Message.toObjectList(msg.getSchedulesList(),
    proto.schedulemanager.ScheduleRecord.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.schedulemanager.SchedulesResponse}
 */
proto.schedulemanager.SchedulesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.schedulemanager.SchedulesResponse;
  return proto.schedulemanager.SchedulesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.schedulemanager.SchedulesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.schedulemanager.SchedulesResponse}
 */
proto.schedulemanager.SchedulesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.schedulemanager.ScheduleRecord;
      reader.readMessage(value,proto.schedulemanager.ScheduleRecord.deserializeBinaryFromReader);
      msg.addSchedules(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.schedulemanager.SchedulesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.schedulemanager.SchedulesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.schedulemanager.SchedulesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.schedulemanager.SchedulesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSchedulesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.schedulemanager.ScheduleRecord.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ScheduleRecord schedules = 1;
 * @return {!Array<!proto.schedulemanager.ScheduleRecord>}
 */
proto.schedulemanager.SchedulesResponse.prototype.getSchedulesList = function() {
  return /** @type{!Array<!proto.schedulemanager.ScheduleRecord>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.schedulemanager.ScheduleRecord, 1));
};


/**
 * @param {!Array<!proto.schedulemanager.ScheduleRecord>} value
 * @return {!proto.schedulemanager.SchedulesResponse} returns this
*/
proto.schedulemanager.SchedulesResponse.prototype.setSchedulesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.schedulemanager.ScheduleRecord=} opt_value
 * @param {number=} opt_index
 * @return {!proto.schedulemanager.ScheduleRecord}
 */
proto.schedulemanager.SchedulesResponse.prototype.addSchedules = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.schedulemanager.ScheduleRecord, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.schedulemanager.SchedulesResponse} returns this
 */
proto.schedulemanager.SchedulesResponse.prototype.clearSchedulesList = function() {
  return this.setSchedulesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.schedulemanager.EnableScheduleRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.schedulemanager.EnableScheduleRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.schedulemanager.EnableScheduleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.schedulemanager.EnableScheduleRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    enabled: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.schedulemanager.EnableScheduleRequest}
 */
proto.schedulemanager.EnableScheduleRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.schedulemanager.EnableScheduleRequest;
  return proto.schedulemanager.EnableScheduleRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.schedulemanager.EnableScheduleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.schedulemanager.EnableScheduleRequest}
 */
proto.schedulemanager.EnableScheduleRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.schedulemanager.EnableScheduleRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.schedulemanager.EnableScheduleRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.schedulemanager.EnableScheduleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.schedulemanager.EnableScheduleRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.schedulemanager.EnableScheduleRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.schedulemanager.EnableScheduleRequest} returns this
 */
proto.schedulemanager.EnableScheduleRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool enabled = 2;
 * @return {boolean}
 */
proto.schedulemanager.EnableScheduleRequest.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.schedulemanager.EnableScheduleRequest} returns this
 */
proto.schedulemanager.EnableScheduleRequest.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * @enum {number}
 */
proto.schedulemanager.SCHEDULE_TYPE = {
  EVIDENCE_COLLECTION: 0,
  EXAMINATION_AND_TEST: 1,
  PLAYBOOK: 2
};

/**
 * @enum {number}
 */
proto.schedulemanager.SCHEDULE_OCCURRENCE = {
  SCHEDULE_OCCURRENCE_ONE_TIME: 0,
  SCHEDULE_OCCURRENCE_RECURRING: 1
};

/**
 * @enum {number}
 */
proto.schedulemanager.SCHEDULE_EXPRESSION_TYPE = {
  SCHEDULE_EXPRESSION_TYPE_RATE: 0,
  SCHEDULE_EXPRESSION_TYPE_CRON: 1
};

/**
 * @enum {number}
 */
proto.schedulemanager.SCHEDULE_RATE_UNIT = {
  SCHEDULE_RATE_UNIT_DAYS: 0,
  SCHEDULE_RATE_UNIT_HOURS: 1,
  SCHEDULE_RATE_UNIT_MINUTES: 2
};

/**
 * @enum {number}
 */
proto.schedulemanager.SCHEDULE_STATUS = {
  SCHEDULE_PENDING: 0,
  SCHEDULE_RUNNING: 1,
  SCHEDULE_COMPLETED: 2,
  SCHEDULE_ERROR: 3
};

goog.object.extend(exports, proto.schedulemanager);
